<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Mutation of Fixed Assets (User/Location Change)  
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" >Delete</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>

      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="7">
              <b-row no-gutters>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asetid" placeholder="FA Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">FA Name &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.asdesc" placeholder="FA Name/Description"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>                      
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asmodel" placeholder="Model/Type/Series"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">S/N &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.asserial" placeholder="Serial Number"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>        
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

        </b-col>
        <b-col lg="4">
                  <b-input-group >
                    <b-input-group-prepend><label>Mutation Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>User</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asuser" placeholder="User"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>

                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.aslocat" placeholder="Location"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuAssetlocatShow=true">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                   <div style="text-align:right;margin-top:5px;">
                    <b-button variant="success" size="sm" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                   </div>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(tanggal)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{data.item.tanggal| moment('D-MMM-YY')}} 
          </div>
          <div v-else> 
          {{data.item.tanggal| moment('D-MMM-YY')}} 
          </div>
        </template>
        <template v-slot:cell(aslocat)="data">
          <span v-if="(data.item.namalokasi)">{{data.item.kodelokasi}} | {{data.item.namalokasi}}</span>
          <span v-else>{{data.item.aslocat}}</span>
        </template>
        <template v-slot:cell(asuser)="data">
          <span v-if="(data.item.crewname)">{{data.item.crewnik}} | {{data.item.crewname}}</span>
          <span v-else>{{data.item.asuser}}</span>
        </template>

      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Form - Mutation User/Location of Fixed Asset  
        <div class="card-header-actions">
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
          <b-col lg="6" >
                <b-row no-gutters >
                  <b-col lg="5" >
                    <b-input-group class="pr-1">
                        <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">                            
                    <b-input-group >
                        <b-form-input v-model="model.asdesc" readonly></b-form-input>                                        
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial"  readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Purchase Order#</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomorpo" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input disabled v-model="model.asdatacq" type="date"  readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.catgname" readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col lg="7" >
                    <b-input-group >
                        <b-input-group-prepend><label>Warranty Desc./Note</label></b-input-group-prepend>
                        <b-form-input v-model="model.txtgaransi" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Expired Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tglgaransi" type="date" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="model.vendorinfo" disabled></b-form-input>                                        
                </b-input-group>
          </b-col>
          <b-col lg="6" v-show="(model.asetkey)">
            
              <b-row>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Mutation Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.tanggal" type="date" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                    </b-input-group>
                  </b-col>
              </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Mutation Description</label></b-input-group-prepend>
                    <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>                                        
                </b-input-group>
                <b-input-group >
                      <b-input-group-prepend><label>Usage Type </label></b-input-group-prepend>
                      <b-form-radio-group  v-model="model.aspublic" name="radioPublic" class="ml-1 mt-1" :state="!$v.model.aspublic.$error" @change="updateUser">
                          <b-form-radio :value="1">Department/Public(used together)</b-form-radio>
                          <b-form-radio :value="0">Dedicated Employee</b-form-radio>
                      </b-form-radio-group>
                </b-input-group>
                <b-row no-gutters>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>User of Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asuser" placeholder="usage remark"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">
                    <b-input-group >
                        <b-form-input readonly v-model="model.crewinfo"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" :disabled="(model.aspublic==1)" :state="!$v.model.crewkey.$error">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Location of Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.aslocat" placeholder="location remark"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">
                    <b-input-group >
                        <b-form-input readonly v-model="model.lokasiinfo"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuAssetlocatShow=true">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
              <div style="text-align:right;">
                <button class="btn btn-primary mr-1" @click="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</button>
              </div>

          </b-col>
        </b-row>
    </b-card>
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>        
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuAssetlocatShow" size="lg" :hide-footer="true" title="List of Location" :centered="true">
            <lku-assetlocat @click="onSelectLkuAssetlocat"></lku-assetlocat>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import fa_mutation from "../../apis/fa_mutasi";
import dropdown from "../../data/dropdown";
import myNumber from "../../components/my-number";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import lkuCrew from "../lookup/lkuCrewFull";
import lkuAssetlocat from "../lookup/lkuAssetlocat";
import { validationMixin } from "vuelidate";
import { required, minValue,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuFixedasset, lkuCrew, lkuAssetlocat},
  mixins: [validationMixin],
  validations: {
        model: {
          tanggal: { required },
          uraian: { required },
          aspublic: { required},
          crewkey: {required : (function() {
                if ((this.model.aspublic || 0) == 0) {
                    return true;
                } else if (!(this.model.crewkey)){
                    return false;
                } else return true;
            })},
        },
  },
  data() {
    return {
      showDelConfirm: false,
      lkuFixedAssetData:{},
      lkuFixedAssetShow: false,
      lkuCrewData:{},
      lkuCrewShow:false,
      lkuAssetlocatShow:false,
      showList:true,
      showForm:false,
      showFilter:false,
      isLoading:false,
        showReport:false,
      reportUrl: null,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: null,
        sortDesc: false
      },
      terpilih:{mutasikey:''},
      model: {tanggal:this.$store.state.user.tglaktif,uraian:'', asuser:'', aspublic:0,crewkey:'',aslocatkey:'', aslocat:''},
      uanguser:this.$store.state.user.matauang,
      YesNoAll: dropdown.YesNoAll,
      categories:[],
      categoriesFrm:[]
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Mutaion Date",
            sortable: true
          },
          {
            key: "uraian",
            label: "Mutaion Description",
          },
          {
            key: "aslocat",
            label: "Location",
           sortable: true
          },
          {
            key: "asuser",
            label: "User",
            sortable: true
          },
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name/Description",
            thStyle: "width:200px",
          },
          {
            key: "asmodel",
            label: "Model/Type/Series",
            thStyle: "width:150px",
          },
          {
            key: "asserial",
            label: "Product/Serial Number",
            thStyle: "width:100px",
          },
          {
            key: "asyermad",
            label: "Made",
            thStyle: "width:40px",
          },
          {
            key: "catgname",
            label: "Category/Group",
            thStyle: "width:120px",
            sortable: true
          },

        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },

  },
  created: async function(){
      const [a] = await Promise.all([fa_mutation.category()]) ;
        this.categories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
      
      this.categoriesFrm=a;
      // this.adjustGroups = b;
  },  
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    // },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await fa_mutation.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table)  this.$refs.table.refresh();
    },
    saveFilter() {
      const keys = ['asetid', 'asdesc', 'asmodel', 'asserial', 'asuser', 'aslocat', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal'];
      let filtered = false;
      const AssetMutasiList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              AssetMutasiList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          AssetMutasiList.page=this.tblData.page;
          AssetMutasiList.limit=this.tblData.limit;
          AssetMutasiList.sortBy=this.tblData.sortBy;
          AssetMutasiList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.AssetMutasiList=AssetMutasiList;
          this.$store.commit("filter", filter);
      }
    },    

    clearFilter(ctx) {
        this.tblData.asetid=  '';
        this.tblData.asdesc=  '';
        this.tblData.asmodel=  '';
        this.tblData.asserial=  '';
        this.tblData.asuser=  '';
        this.tblData.aslocat=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    updateUser: function(){
        if (this.model.aspublic==0) {
          this.model.crewkey='';
          this.model.crewinfo='';
          this.model.asuser='G & A Department';
        } else {
          this.model.asuser='';
        }
    },

    add(){
      this.saveFilter();
      router.push({name :"fixedasset.mutationfrm"});
    },
    edit: function() {
        if (this.terpilih.mutasikey) {
          this.saveFilter();
          router.push({name :'fixedasset.mutationfrm', params: { mutasikey: this.terpilih.mutasikey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.expMode='acc';
            const response = await fa_mutation.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    deleteConfirm() {
      if (this.terpilih.mutasikey) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
      await fa_mutation.remove(this.terpilih);
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.terpilih.mutasikey==record.mutasikey) {
        console.log('terpilih row click: ', this.terpilih);
        this.edit();
      } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    print: async function()
    {
      if (this.terpilih.mutasikey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await fa_mutation.print(this.terpilih);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },    
    onSelectLkuFixedAsset(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;

        this.model.asetkey = lkuData.selected.asetkey;
        this.model.asetid = lkuData.selected.asetid;
        this.model.asdesc = lkuData.selected.asdesc;
        this.model.lamathn = lkuData.selected.lamathn;
        this.model.lamabln = lkuData.selected.lamabln;
        this.model.lamathnB4 = lkuData.selected.lamathn;
        this.model.lamablnB4 = lkuData.selected.lamabln;
        this.model.NilaiNettB4 = lkuData.selected.NilaiNett;
        this.model.depaccumB4 = lkuData.selected.Penyusutan;
        this.model.catgname = lkuData.selected.catgname;
        this.model.matauang = lkuData.selected.matauang;
        this.model.asmodel = lkuData.selected.asmodel;
        this.model.asserial = lkuData.selected.asserial;
        this.model.asyermad = lkuData.selected.asyermad;
        this.model.supplierinfo = lkuData.selected.supplierinfo;
        this.model.aspurcpri = lkuData.selected.aspurcpri;
        this.model.asdatacq = moment(lkuData.selected.asdatacq).format('YYYY-MM-DD');
    },
    onSelectLkuCrew: function(lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.tblData.asuser = lkuData.selected.crewname.trim();
        this.model.crewkey = lkuData.selected.crewkey;
        this.model.crewnik = this.model.crewnik;
        this.model.jabatan = lkuData.selected.jabatan;
        this.model.departemen = this.model.departemen;
        this.lkuCrewShow=false;
    },
    onSelectLkuAssetlocat: async function (_selected) {
        this.model.lokasiinfo = _selected.kodelokasi.trim() + ' | ' + _selected.namalokasi.trim();
        this.tblData.aslocat = _selected.namalokasi.trim();
        this.model.aslocatkey = _selected.aslocatkey;
        this.model.kodelokasi = this.model.kodelokasi;
        this.model.namalokasi = _selected.namalokasi;
        this.lkuAssetlocatShow=false;
    },

    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
